import { Button, Form } from 'react-bootstrap';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import spinnerTitle from '../../others/spinnerTitle';

interface WarehouseApiIdentFormProps {
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
    isSubmitting: boolean;
    error?: string;
}

const WarehouseApiIdentForm = ({ handleSubmit, isSubmitting, error }: WarehouseApiIdentFormProps) => {
    const { t } = useTranslation(['Warehouses', 'common']);
    const refInput = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setTimeout(() => {
            if (refInput.current) {
                refInput.current.focus();
            }
        }, 100);
    }, []);

    return (
        <Form className="d-flex flex-column h-100" onSubmit={handleSubmit}>
            <div className="off-create-team-form d-flex flex-column h-100">
                <div className="off-create-team-content px-3">
                    <Form.Group className="mb-3">
                        <label className="form-label text-muted" htmlFor="warehouseIdApi">
                            {t('apiIdent.label')}
                        </label>
                        <Field
                            innerRef={refInput}
                            id="warehouseIdApi"
                            name="warehouseIdApi"
                            className={`form-control ${error ? 'is-invalid' : ''}`}
                            autoFocus
                        />
                        {error ? <div className="invalid-feedback d-block">{error}</div> : null}
                        <Form.Text className="text-muted">{t('apiIdent.hint')}</Form.Text>
                    </Form.Group>
                </div>

                <div className="p-3 offcanvas-footer off-create-team-footer">
                    <div className="d-flex justify-content-end">
                        <Button type="submit" variant="info" disabled={isSubmitting} className="min100px">
                            {spinnerTitle(
                                <>
                                    <i className="bi bi-check2-all fs-14 me-2"></i>
                                    {t('common:buttons.save')}
                                </>,
                                isSubmitting,
                                t('common:buttons.saving'),
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default WarehouseApiIdentForm;
